export const MQ24GPGA460Model = {
    name: "",
    description: "",
    model: "MQ24G",
    format: "b",
    payload: {}
}
export const MQ24GPGA460BasicModel = {
    TVGAIN0: "AA",
    TVGAIN1: "AA",
    TVGAIN2: "AA",
    TVGAIN3: "51",
    TVGAIN4: "45",
    TVGAIN5: "14",
    TVGAIN6: "50",
    INIT_GAIN: "54",
    FREQUENCY: "32",
    DEADTIME: "A0",
    PULSE_P1: "08",
    PULSE_P2: "10",
    CURR_LIM_P1: "40",
    CURR_LIM_P2: "40",
    REC_LENGTH: "19",
    FREQ_DIAG: "33",
    SAT_FDIAG_TH: "EE",
    FVOLT_DEC: "7C",
    DECPL_TEMP: "4F",
    DSP_SCALE: "00",
    TEMP_TRIM: "00",
    P1_GAIN_CTRL: "09",
    P2_GAIN_CTRL: "09",
    P1_THR_0: "FF",
    P1_THR_1: "F0",
    P1_THR_2: "E8",
    P1_THR_3: "D8",
    P1_THR_4: "C8",
    P1_THR_5: "B8",
    P1_THR_6: "A8",
    P1_THR_7: "98",
    P1_THR_8: "88",
    P1_THR_9: "78",
    P1_THR_10: "68",
    P1_THR_11: "58",
    P1_THR_12: "48",
    P1_THR_13: "38",
    P1_THR_14: "28",
    P1_THR_15: "18",
    P2_THR_0: "FF",
    P2_THR_1: "F0",
    P2_THR_2: "E8",
    P2_THR_3: "D8",
    P2_THR_4: "C8",
    P2_THR_5: "B8",
    P2_THR_6: "A8",
    P2_THR_7: "98",
    P2_THR_8: "88",
    P2_THR_9: "78",
    P2_THR_10: "68",
    P2_THR_11: "58",
    P2_THR_12: "48",
    P2_THR_13: "38",
    P2_THR_14: "28",
    P2_THR_15: "18",
}

export const MQ24GPGA460AdvancedModel = {
    EE_CRC: "00",
    EE_CNTRL: "00",
    BPF_A2_MSB: "00",
    BPF_A2_LSB: "00",
    BPF_A3_MSB: "00",
    BPF_A3_LSB: "00",
    BPF_B1_MSB: "00",
    BPF_B1_LSB: "00",
    LPF_A2_MSB: "00",
    LPF_A2_LSB: "00",
    LPF_B1_MSB: "00",
    LPF_B1_LSB: "00",
    TEST_MUX: "00",
    DEV_STAT0: "00",
    DEV_STAT1: "00",
}